import { filterTypes } from '@nykaa/listing-shared/constants/filter';
import MultiSelect from './MultiSelect';
import Category from './Category';
import Color from './Color';
import SingleSelect from './SingleSelect';
import RangeSelector from './RangeSelector';


//component MAP
export default class ComponentMap {
  public static get(type: string) {
    switch (type) {
      case filterTypes.MULTI_SELECT:
        return MultiSelect;
      case filterTypes.CATEGORY:
        return Category;
      case filterTypes.COLOR:
        return Color;
      case filterTypes.SINGLE_SELECT:
        return SingleSelect;
      case filterTypes.RANGE:
        return RangeSelector;
      default:
        return MultiSelect;
    }
  }
}
